import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import { map } from 'rxjs';
import { IResponse } from '../models/response';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: "root",
})
export class FolderService {

  constructor(private _http: HttpClient) { }

  getAllFoldersByProjectId(projectId: string, type) {
    let params = {
      project: projectId,
      type
    }
    return this._http.get(apiconstants.API_FOLDERS, {params}).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  addFolder(projectId, folderName: string, folderType, parent?) {
    let params = {
      project: projectId,
      name: folderName,
      type: folderType,
    }
    if(parent) {
      params['parent'] = parent;
    }
    return this._http.post(apiconstants.API_FOLDERS, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  renameFolder(folderId, folderName: string) {
    let params = {
      id: folderId,
      name: folderName
    }
    return this._http.post(apiconstants.API_FOLDERS, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  deleteFolder(folderId: string) {
    return this._http.delete(apiconstants.API_FOLDERS + '/' + folderId).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
}
